import styled from 'styled-components';

export const PhoneAuthCodeContainer = styled.div`
    display: flex;
    margin-top: 8px;
    justify-content: space-between;
    border-radius: 8px;
    position: relative;
`;

export const InputNumberWrapper = styled.div`
    width: 100%;
`;

export const LabelBtnWrapper = styled.div`
    position: absolute;
    display: flex;
    right: 0;
`;

export const LabelTimerWrapper = styled.div`
    line-height: 56px;
`;

export const BtnAuthVerfiyWrapper = styled.div`
    width: 100px;
    line-height: 56px;
    margin-right: 22px;
    margin-left: 12px;
`;
